<!-- <template>
  <div class="swiper-container" :style="{ width: '90%', margin: '0 auto' }">
    <swiper :slides-per-view="slidesPerView" :space-between="30" @swiper="onSwiper" @slideChange="onSlideChange" :slides-per-group="slidesPerView"
      loop="true">
      <swiper-slide>
        <div class="slide-content">
          <img src="@/assets/home-three-icon.png" />
          <h1>ITERATE1</h1>
          <h3>Innovative Strategy and Curation</h3>
          <p> We provide some of the biggest Corporations (USA, Canada, Europe) with Market Landscaping and Innovative
            Strategy Solutions including technology and service solutions for customer engagement blueprints,
            technical due diligence and emerging technology application. With our seasoned team of Researchers and the
            knowledge of business strategies, we provide tailor-made and innovative solutions that help Global leaders
            in Fashion, Retail, Sports and other industries, work with agile solutions. </p>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-content">
          <img src="@/assets/home-three-icon.png" />
          <h1>ITERATE2</h1>
          <h3>Innovative Strategy and Curation</h3>
          <p> We provide some of the biggest Corporations (USA, Canada, Europe) with Market Landscaping and Innovative
            Strategy Solutions including technology and service solutions for customer engagement blueprints,
            technical due diligence and emerging technology application. With our seasoned team of Researchers and the
            knowledge of business strategies, we provide tailor-made and innovative solutions that help Global leaders
            in Fashion, Retail, Sports and other industries, work with agile solutions. </p>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-content" style="margin-top: 50px;">
          <img src="@/assets/home-three-icon.png" />
          <h1>ITERATE3</h1>
          <h3>Innovative Strategy and Curation</h3>
          <p> We provide some of the biggest Corporations (USA, Canada, Europe) with Market Landscaping and Innovative
            Strategy Solutions including technology and service solutions for customer engagement blueprints,
            technical due diligence and emerging technology application. With our seasoned team of Researchers and the
            knowledge of business strategies, we provide tailor-made and innovative solutions that help Global leaders
            in Fashion, Retail, Sports and other industries, work with agile solutions. </p>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-content">
          <img src="@/assets/home-three-icon.png" />
          <h1>ITERATE4</h1>
          <h3>Innovative Strategy and Curation</h3>
          <p> We provide some of the biggest Corporations (USA, Canada, Europe) with Market Landscaping and Innovative
            Strategy Solutions including technology and service solutions for customer engagement blueprints,
            technical due diligence and emerging technology application. With our seasoned team of Researchers and the
            knowledge of business strategies, we provide tailor-made and innovative solutions that help Global leaders
            in Fashion, Retail, Sports and other industries, work with agile solutions. </p>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev" @click="slidePrev"><img width="100%" src="@/assets/btn-next.png" /></div>
    <div class="swiper-button-next" @click="slideNext"><img width="100%" src="@/assets/btn-next.png" /></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';

const swiperInstance = ref(null);
const slidesPerView = ref(1);

const updateSlidesPerView = () => {
  slidesPerView.value = window.innerWidth < 600 ? 1 : 2;
};

onMounted(() => {
  updateSlidesPerView();
  window.addEventListener('resize', updateSlidesPerView);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateSlidesPerView);
});

const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
};

const onSlideChange = () => {
  console.log('slide change');
};

const slidePrev = () => {
  if (swiperInstance.value) {
    swiperInstance.value.slidePrev();
  }
};

const slideNext = () => {
  if (swiperInstance.value) {
    swiperInstance.value.slideNext();
  }
};
</script>

<style lang="less" scoped>
.swiper-container {
  position: relative;

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;

    &::after {
      content: none;
    }
  }

  .swiper-button-prev {
    left: 10px;
    transform: rotate(180deg);
  }

  .swiper-button-next {
    right: 10px;
  }

  .slide-content {
    display: flex;
    // align-items: center;
    justify-content: center;
    // background-color: #f0f0f0;
    // border: 1px solid #ccc;
    flex-direction: column;
    text-align: left;

    img {
      width: 200px;
      margin-bottom: 10px;
    }

    h1 {
      font-size: 2vw;
      margin-bottom: 5px;
    }

    h3 {
      font-size: 1.5vw;
      margin-bottom: 10px;
    }

    p {
      font-size: 1vw;
      line-height: 1.5;
    }

  }
}
</style> -->

<template>
  <div class="contain" ref="contain">
    <div class="wow animate__zoomInRight"
      style="font-size: max(7vw,48px);text-transform: uppercase;color: hsla(0,0%,100%,.3);font-weight: 600;letter-spacing:1px">Contact</div>
    <div class="wow animate__zoomInRight" data-wow-delay="0.3s"
      style="font-size: max(5vw,24px);text-transform: uppercase;color: #fff;font-weight: 600;letter-spacing:1px">Contact</div>
  </div>

  <div class="container2" ref="container2">
    <h1 class="wow animate__fadeInUp" data-wow-delay="0.1s">Engage with our Way of Work & <br />Explore our Services in Detail</h1>
    <div class="wow animate__fadeInUp" data-wow-delay="0.2s"><a href="mailto:Hello@mydigim.com?subject=Hello&body=This is a email.">Send</a></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';


const contain = ref(null);
const container2 = ref(null);
let observer = null;

const handleIntersection = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('clip-path-effect');
    } else {
      entry.target.classList.remove('clip-path-effect');
    }
  });
};
onMounted(() => {
  observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.05 // 当元素 10% 进入视口时触发
  });
  if (contain.value) {
    observer.observe(contain.value);
  }
  if (container2.value) {
    observer.observe(container2.value);
  }
});

onUnmounted(() => {
  if (observer && contain.value) {
    observer.unobserve(contain.value);
  }
  if (observer && container2.value) {
    observer.unobserve(container2.value);
  }
});

</script>

<style lang="less" scoped>
.contain {
  background-image: url('../assets/contact-bg.png') !important;
  background-repeat: no-repeat;
  background-position: center right;
  background-color: #fff;
  background-size: cover;
  min-height: 80vh;
  position: relative;
  overflow: hidden;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果

  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 70%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 70%);
  }

  >div:nth-child(1) {
    position: absolute;
    top: 63%;
    right: 10%;
  }

  >div:nth-child(2) {
    position: absolute;
    top: 69%;
    right: 14%;
  }
}

.container2 {
  margin-top: -250px;
  background-image: url('../assets/contact-bg1.png') !important;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: #fff;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  color: #172d43;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
  }

  >h1 {
    font-weight: 500;
    font-size: max(2vw, 18px);
    line-height: 1.5;
  }
  >div {
    text-transform: uppercase;
    background-color: #ff7a59;
    padding: 10px 30px;
    border-radius: 30px;
    cursor: pointer;
    color: #fff;

    >a {
      color: inherit;
      text-decoration: none;
      outline: none;
    }
  }
}
@media all and (max-width:600px) {
  .contain {
    min-height: 0px;
    aspect-ratio: 5/7 !important;

    >div:nth-child(1) {
      position: absolute;
      top: 40%;
      right: 10%;
    }

    >div:nth-child(2) {
      position: absolute;
      top: 45%;
      right: 15%;
    }
  }

  .container2 {
    min-height: 0px;
    aspect-ratio: 5/7 !important;

    &.clip-path-effect {
      -webkit-clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
      clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
    }
  }
}
</style>

